(function () {
  const EVENT_NAME = 'cart_modal_view';
  const LISTENER_FLAG = '__customCartModalDatalayerBound';

  if (window[LISTENER_FLAG]) return;
  window[LISTENER_FLAG] = true;

  function getPageType() {
    const bodyClass = document.body?.className || '';
    const templateClass = bodyClass
      .split(' ')
      .find((className) => className.endsWith('-template'));

    return templateClass ? templateClass.replace('-template', '') : '';
  }

  function onCartDrawerAfterShow(event) {
    const target = event?.target;
    if (!target || target.tagName?.toLowerCase() !== 'cart-drawer') return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: EVENT_NAME,
      source: 'cart-drawer',
      page_type: getPageType(),
    });
  }

  document.addEventListener('drawer:handleAfterShow', onCartDrawerAfterShow);
})();
